import { useId } from 'react';
import { COLOR_NAMES } from '../lib/palette.js';
import { teinte } from '../lib/teinte.js';

/**
 * `.choix-teinte` du kit : des radios natifs, une pastille chacun. Le clavier (flèches) et
 * l'annonce viennent du groupe radio ; la couleur vient des données, posée dans `--teinte`.
 */
export function ColorPicker({
  palette,
  value,
  onChange,
  label,
}: {
  palette: readonly string[];
  value: string;
  onChange: (color: string) => void;
  label: string;
}): React.ReactElement {
  const name = useId();
  // Une couleur enregistrée qui a depuis quitté la palette reste proposée : sans ça, ouvrir
  // le formulaire et l'enregistrer la changerait sans qu'on l'ait demandé.
  const colors = palette.includes(value) ? palette : [...palette, value];
  return (
    <div className="rangee" role="radiogroup" aria-label={label}>
      {colors.map((c) => (
        <label key={c} className="choix-teinte" style={teinte(c)}>
          <input type="radio" name={name} checked={value === c} onChange={() => onChange(c)} />
          <span className="visuellement-cache">{COLOR_NAMES[c] ?? c}</span>
        </label>
      ))}
    </div>
  );
}
